import React, {useEffect, useState} from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Snackbar,
    Alert,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    CardContent,
    Typography,
    Card
} from '@mui/material';
import {IoIosCloseCircle} from "react-icons/io";
import axios from 'axios';
import ConfirmationModal from "../../ConfirmationModal/ConfirmationModal";
import {MdDelete, MdEdit, MdInfoOutline} from "react-icons/md";
import "./ChatComponent.css"
import EditChatUsers from "./EditChatUsers";
import CaseFilesDialog from "../../../dashboard/apiTables/СaseFilesDialog";
import {FcDocument} from "react-icons/fc";
import {TbReportSearch} from "react-icons/tb";

const EditChatGroupPopup = ({open, onClose, group, onChatEdit, users, isCaseChat}) => {
    const [isConfirmOpen, setConfirmOpen] = useState(false);
    const [isUserEditPopupOpen, setIsUserPopupOpen] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [dialogOpen, setDialogOpen] = useState(false);
    const rolesInGeorgian = {
        'HEADOFAGENCY': "სააგენტოს უფროსი",
        'DEPUTYHEADOFAGENCY': "უფროსის მოადგილე",
        'HEADOFDEPARTMENT': "სამმართველოს უფროსი",
        'EXPERT': "სპეციალისტი"
    };

    const handleOpenDialog = () => {
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    const handleCaseNumberClick = (caseId) => {
        window.open(`/dashboard/mycases/casemanager?id=${caseId}`, '_blank');
    };


    const findUserById = (userId) => {
        const user = users.find(user => user.id === userId)
        if (user) {
            return `${user.firstName} ${user.lastName} (${rolesInGeorgian[user.roleName.toUpperCase()]})`
        } else {
            return userId
        }


    }

    const handleDelete = async (groupId) => {
        try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeleteChatGroup`, {id: groupId});
            setSnackbarMessage("Chat group deleted successfully");
            setSnackbarSeverity("success");
            onChatEdit();
            onClose();
        } catch (error) {
            console.error('Failed to delete chat group:', error);
            setSnackbarMessage("Failed to delete chat group");
            setSnackbarSeverity("error");
        } finally {
            setSnackbarOpen(true);
        }
    };

    const openConfirmation = () => setConfirmOpen(true);
    const openUserEditPopup = () => setIsUserPopupOpen(!isUserEditPopupOpen);
    const closeConfirmation = () => setConfirmOpen(false);
    const handleCloseSnackbar = () => setSnackbarOpen(false);

    return (
        <Dialog fullWidth maxWidth="lg" open={open} onClose={onClose}>
            <IoIosCloseCircle className="upload-single-close-icon-text-editor" onClick={onClose}/>
            <DialogTitle>ჩატის პარამეტრები</DialogTitle>
            <DialogContent>
                <div style={{display: 'flex', flexDirection: 'column'}}>

                    <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: 20, gap: 20}}>
                        <Card sx={{width: 300}}>
                            <CardContent>
                                <Typography variant="h6" color="text.secondary" style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '5px',
                                    marginBottom: 10
                                }}>
                                    <MdInfoOutline/>
                                    ინფორმაცია
                                </Typography>
                                <Typography variant="body2">
                                    ჩათის სახელი: {group.chatName}
                                </Typography>
                                <Typography variant="body2">
                                    განაცხადის ნომერი: {group.caseNumber || "ჩატი არ არის მიბმული განაცხადს!"}
                                </Typography>
                                <Typography variant="body2">
                                    შეიქმნა: {new Date(group.createDate).toLocaleString('en-GB', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    second: '2-digit',
                                    hour12: false
                                })}
                                </Typography>
                            </CardContent>
                        </Card>
                        <TableContainer
                            component={Paper}
                            className="custom-scrollbar"
                            sx={{
                                maxHeight: 400,
                                overflow: 'auto',
                                maxWidth: 900,
                                '&::-webkit-scrollbar': {
                                    width: '8px'
                                },
                                '&::-webkit-scrollbar-track': {
                                    background: '#f0f0f0'
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    backgroundColor: '#bbbbbb',
                                    borderRadius: '10px',
                                    border: '2px solid #ffffff'
                                }
                            }}

                        >
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>მომხმარებლები</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {group.chatUsersIds.map((userId) => (
                                        <TableRow key={userId}>
                                            <TableCell component="th" scope="row">
                                                {findUserById(userId)}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>


                    </div>
                    {

                    }
                    {
                        isCaseChat ? (
                                <Button style={{width: 200}} variant="contained" color="primary" onClick={openUserEditPopup}
                                        startIcon={<MdEdit/>}>
                                    რედაქტირება
                                </Button>
                            ) :
                            group.caseID ? (
                                <>
                                    <CaseFilesDialog open={dialogOpen} onClose={handleCloseDialog} caseId={group.caseID}
                                                     users={users} isChatPopup={true}/>
                                    <div style={{display: 'flex', gap: 10}}>
                                        <Button variant="contained" color="primary" onClick={handleOpenDialog}
                                                startIcon={<FcDocument/>}>
                                            დოკუმენტაციის ნახვა
                                        </Button>
                                        <Button variant="contained" color="secondary"
                                                onClick={() => handleCaseNumberClick(group.caseID)}
                                                startIcon={<TbReportSearch/>}>
                                            განაცხადის ნახვა
                                        </Button>
                                    </div>
                                </>


                            ) : (
                                <div style={{display: 'flex', gap: 10}}>
                                    <Button variant="contained" color="primary" onClick={openUserEditPopup}
                                            startIcon={<MdEdit/>}>
                                        რედაქტირება
                                    </Button>
                                    <Button variant="contained" color="error" onClick={openConfirmation}
                                            startIcon={<MdDelete/>}>
                                        ჩატის წაშლა
                                    </Button>
                                </div>
                            )}


                </div>
                {isUserEditPopupOpen && (
                    <EditChatUsers
                        open={isUserEditPopupOpen}
                        onClose={openUserEditPopup}
                        group={group}
                        users={users}
                        onUpdate={onChatEdit}
                        closeAllPopups={onClose}
                        isCaseChat={isCaseChat}
                    />
                )}
            </DialogContent>


            <DialogActions>
            </DialogActions>
            <ConfirmationModal
                isOpen={isConfirmOpen}
                onRequestClose={closeConfirmation}
                onConfirm={() => handleDelete(group.id)}
            />
            <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{width: '100%'}}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Dialog>
    );
};

export default EditChatGroupPopup;
